export const history = {
  refresh: "Refresh",
  noData: "@:common.global.noData",
  all: "All",
  NA: "N/A",
  loading: "Loading...",
  dataType: {
    alert: "Alert",
    driver: "Driver",
    fleet: "Fleet",
    vehicle: "Vehicle",
  },
  alertSelect: {
    geofencingEnter: "Geofencing - Enter",
    DSSFatigue: "DSS - Fatigue",
    PDFrontCritical: "PD - Front Critical",
    PDRearCritical: "PD - Rear Critical",
    PDLeftCritical: "PD - Left Critical",
    PDRightCritical: "PD - Right Critical",
    PDFrontRightCritical: "PD - FrontRight Critical",
    PDRearRightCritical: "PD - RearRight Critical",
    geofencingExit: "Geofencing - Exit",
    DSSPhone: "DSS - Phone Usage",
    DSSSmoking: "DSS - Smoking",
    DSSCameraBlocked: "DSS - Camera Blocked",
    speeding: "DSS - Speeding",
    unauthorizedDriver: "Unauthorized Driver",
    seatbelt: "DSS - Seatbelt Unfastened",
    hardHatOff: "DSS - Hardhat Off",
    cameraShift: "Camera Shift",
    leaveSeat: "DSS - Leave Seat",
    driverChanged: "DSS - Driver Changed",
  },
  alertSearch: {
    placeholder: "Vehicle ID",
  },
  alert: {
    listView: "List View",
    mapView: "Map View",
    alertsWithGPSTotal: "Alerts with GPS",
    mapTypeBottomSwitch: "Map Type",
    failedToGetMoreData: "Failed to get more data.",
    failedToGetLocation: "Failed to get location.",
    time: "Time",
    events: "Alerts",
    driver: "Driver",
    fleet: "Fleet",
    vehicleID: "Vehicle ID",
    speed: "Speed",
    unknownDriver: "@:common.global.unknownDriver",
    snapshotPhotos: "Snapshot | Snapshot | Snapshots",
    eventLocation: "Alert Location",
    location: "Alert Location",
    authorized: "Authorized",
    yes: "Yes",
    no: "No",
    messages: "Notifications",
    last24hours: "Last 24 hours",
    criticalItemFailed: "@:inspectionReport.criticalItemFailed",
    seatBeltLowBattery: "SeatBelt Low Battery",
    speedSensorLowBattery: "Speed Sensor Low Battery",
    sdCardError: "SD Unrecognized",
    extDssSDCardError: "Extended SD Unrecognized",
  },
  trip: {
    vehicleID: "Vehicle ID",
    driver: "Driver",
    fleet: "Fleet",
    model: "Vehicle Model",
    startLocation: "Start",
    endLocation: "End",
    totalTime: "Trip Duration",
    authorized: "Authorized",
    videoRetrieval: "Video Retrieval",
    secondsBefore: "Seconds Before",
    secondsAfter: "Seconds After",
    time: "Time",
    selectCameras: "Select Cameras",
    notes: "Notes",
    uploadToCloud: "Upload to Cloud",
    rearCamera: "Rear Camera",
    frontCamera: "Front Camera",
    leftCamera: "Left Camera",
    rightCamera: "Right Camera",
    driverCamera: "Driver Camera",
    trip: "Trip",
    sendUploadSuccessfully: "Request sent.",
    pleaseSelectACameraFirst: "You must select at least one camera.",
    videoIsNotReady: "Video is not ready yet, please try later.",
    start: "Start",
    end: "End",
    back: "Back",
  },
  noGpsInfo: "GPS Lost",
  Heat: "Heat",
  Bubble: "Bubble",
  noImage: "No picture or video found",
};
